/**
 * Global Map Instance
 * Allows controls and other components to access the Mapbox map
 */

import type { Map as MapboxMap } from 'mapbox-gl';

let mapInstance: MapboxMap | null = null;

export function setMapInstance(map: MapboxMap | null) {
  mapInstance = map;
}

export function getMapInstance(): MapboxMap | null {
  return mapInstance;
}

export function flyToLocation(lat: number, lng: number, zoom: number = 16) {
  if (mapInstance) {
    mapInstance.flyTo({
      center: [lng, lat],
      zoom,
      pitch: 60,
      bearing: 0,
      duration: 1500,
    });
  }
}

export function zoomIn() {
  if (mapInstance) {
    mapInstance.zoomIn({ duration: 300 });
  }
}

export function zoomOut() {
  if (mapInstance) {
    mapInstance.zoomOut({ duration: 300 });
  }
}

export function resetNorth() {
  if (mapInstance) {
    mapInstance.easeTo({
      bearing: 0,
      pitch: 60,
      duration: 500,
    });
  }
}

export function recenterToUser(lat: number, lng: number) {
  if (mapInstance) {
    mapInstance.flyTo({
      center: [lng, lat],
      zoom: 17,
      pitch: 60,
      bearing: 0,
      duration: 1000,
    });
  }
}
